<template>
    <modal ref="modal" size="large">
        <div slot="title">{{ __('Attachments') }}</div>

        <div slot="body">
            <div class="d-flex justify-content-between">
                <div class="col-sm-12 col-md-12 card-nopadding">
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table datatable">
                                <thead>
                                <tr>
                                    <th>{{ __('Filename') }}</th>
                                    <th>{{ __('Uploaded') }}</th>
                                    <th></th>
                                </tr>
                                </thead>

                                <tbody>
                                <tr v-for="(attachment) in attachments" :key="attachment.id">
                                    <td class="text-left">{{ attachment.filename }}</td>
                                    <td class="text-left">{{ formatDate(attachment.timestamp) }}</td>
                                    <td class="text-right">
                                        <button
                                                class="btn btn-primary ml-2"
                                                @click.prevent="downloadFile(attachment.url)"
                                        >{{ __('Download') }}
                                        </button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import moment from 'moment'
import Vue from 'vue'

export default {
  name: 'AttachmentsModal',

  components: {},

  data () {
    return {
      loadId: null,
      attachments: {}
    }
  },

  methods: {
    show (id) {
      this.loadId = id

      this.$api.shipments.attachmentList(this.loadId)
        .then((res) => {
           this.attachments = res.data
        })

      this.$refs.modal.show()
    },

    close () {
      this.$refs.modal.close()
    },

    formatDate (date) {
      return moment(date).format('YYYY-MM-DD')
    },

    downloadFile (url) {
      window.open(
        Vue.axios.defaults.baseURL + url,
        '_blank' 
      )
      //window.location.href = Vue.axios.defaults.baseURL + url
    }
  }
}
</script>
